import React from 'react';
import { Card, Empty, Typography } from 'antd';
import { F } from '@/utils/intl';

const { Title, Text } = Typography;

export interface KPSMaxPlanViewerProps {
  leadDetails?: any;
  leadId?: string;
  plan?: any;
}

const KPSMaxPlanViewer: React.FC<KPSMaxPlanViewerProps> = ({
  leadDetails,
  leadId,
  plan
}) => {
  return (
    <Card
      title={
        <>
          <F id="pages.lead.drawer.planning.kps-max" defaultMessage="KPS Max Planning" />
        </>
      }
      size="small"
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div>
            <Title level={5}>
              <F id="pages.lead.drawer.planning.kps-max.coming-soon" defaultMessage="KPS Max Planning - Coming Soon" />
            </Title>
            <Text type="secondary">
              <F
                id="pages.lead.drawer.planning.kps-max.description"
                defaultMessage="KPS Max planning functionality will be available here."
              />
            </Text>
          </div>
        }
      />
    </Card>
  );
};

export default KPSMaxPlanViewer;
